import { HomeTab } from '../raw-tab-configs/home-tab';
import { MenuTab } from '../raw-tab-configs/menu-tab';
import { OffersTab } from '../raw-tab-configs/offers-tab';
import { RewardsTab } from '../raw-tab-configs/rewards-tab';
import type { RawTab } from '../types';

export const tabList: Array<RawTab> = [HomeTab, OffersTab, MenuTab, RewardsTab];
export const tabListWithoutEarn: Array<RawTab> = [HomeTab, OffersTab, MenuTab, RewardsTab];
